import { useOutletContext } from 'react-router-dom';

export interface SignOnContext {
  // A card is on screen, so the tenant cover has something to sit behind.
  showCard: () => void;
  // The flow is finishing — drop the cover before the redirect, so the last
  // frame isn't a bare background with no card on it.
  endSignOn: () => void;
}

// Outside the sign-on routes (the showcase gallery, unit tests) there is no
// cover to end, so the call is a no-op rather than a crash.
const NOT_IN_SIGN_ON: SignOnContext = {
  showCard: () => undefined,
  endSignOn: () => undefined,
};

export const useSignOn = () =>
  useOutletContext<SignOnContext | null>() ?? NOT_IN_SIGN_ON;
